module.exports = __webpack_public_path__ + "static/media/journal-icon.65ddd1a3.svg";